import { useMemberSettings } from "@hooks/useMemberSettings";
import { MemberSettingFundingMode } from "kz-ui-sdk";
import { useMemo } from "react";
import { useBankFundingProfileFormController } from "./useBankFundingProfileFormController";
import { useEWalletFundingProfileFormController } from "./useEWalletFundingProfileFormController";

interface UseFundingProfileFormControllerProps {
  defaultFundingMode?: MemberSettingFundingMode;
}

/**
 * Form Controller for the AddFundingProfileForm.
 * Based on the funding mode, it will return the appropriate form schema.
 */
export const useFundingProfileFormController = ({ defaultFundingMode }: UseFundingProfileFormControllerProps) => {
  const { fundingMode: fundingModeFromMemberSettings } = useMemberSettings();
  const fundingMode = useMemo(
    () => defaultFundingMode || fundingModeFromMemberSettings,
    [defaultFundingMode, fundingModeFromMemberSettings],
  );

  const bank = useBankFundingProfileFormController();
  const ewallet = useEWalletFundingProfileFormController();

  return fundingMode === MemberSettingFundingMode.EWalletOnly ? ewallet : bank;
};
